var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup27(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A4162324-D399-41AD-9BCB-52ADAB86808B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.-Who-can-use-Hana-UI",
    transform: "translate(-357.000000, -398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(358.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.69093,22.34545 C44.69093,34.68645 34.68653,44.69085 22.34543,44.69085 C10.00443,44.69085 3e-05,34.68645 3e-05,22.34545 C3e-05,10.00435 10.00443,-5e-05 22.34543,-5e-05 C34.68653,-5e-05 44.69093,10.00435 44.69093,22.34545 Z",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.80734,13.23774 C19.30464,13.23774 19.70754,12.83464 19.70754,12.33724 C19.70754,11.83984 19.30404,11.43674 18.80674,11.43674 C18.30944,11.43674 17.90624,11.83994 17.90624,12.33724 C17.90624,12.83464 18.30944,13.23774 18.80674,13.23774 L18.80734,13.23774 Z",
    id: "Fill-3",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6945,34.3017 C26.1918,34.3017 26.5947,33.8986 26.5947,33.4012 C26.5947,32.9038 26.1912,32.5007 25.6939,32.5007 C25.1966,32.5007 24.7934,32.9038 24.7934,33.4012 C24.7934,33.8986 25.1966,34.3017 25.6939,34.3017 L25.6945,34.3017 Z",
    id: "Fill-5",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.60871,32.65483 C21.10601,32.65483 21.50891,32.25173 21.50891,31.75433 C21.50891,31.25693 21.10541,30.85383 20.60811,30.85383 C20.11071,30.85383 19.70761,31.25693 19.70761,31.75433 C19.70761,32.25173 20.11081,32.65483 20.60811,32.65483 L20.60871,32.65483 Z",
    id: "Fill-7",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.89318,11.61772 C24.39038,11.61772 24.79338,11.21462 24.79338,10.71722 C24.79338,10.21982 24.38988,9.81672 23.89258,9.81672 C23.39518,9.81672 22.99198,10.21982 22.99198,10.71722 C22.99198,11.21462 23.39528,11.61772 23.89258,11.61772 L23.89318,11.61772 Z",
    id: "Fill-9",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6945,15.03881 C26.1918,15.03881 26.5947,14.63561 26.5947,14.13831 C26.5947,13.64091 26.1912,13.23771 25.6939,13.23771 C25.1966,13.23771 24.7934,13.64091 24.7934,14.13831 C24.7934,14.63561 25.1966,15.03881 25.6939,15.03881 L25.6945,15.03881 Z",
    id: "Fill-11",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.60871,37.38383 C21.10601,37.38383 21.50891,36.98073 21.50891,36.48333 C21.50891,35.98593 21.10541,35.58283 20.60811,35.58283 C20.11071,35.58283 19.70761,35.98593 19.70761,36.48333 C19.70761,36.98073 20.11081,37.38383 20.60811,37.38383 L20.60871,37.38383 Z",
    id: "Fill-13",
    fill: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.89128,22.34545 C27.89128,25.40835 25.40828,27.89125 22.34548,27.89125 C19.28258,27.89125 16.79968,25.40835 16.79968,22.34545 C16.79968,19.28255 19.28258,16.79965 22.34548,16.79965 C25.40828,16.79965 27.89128,19.28255 27.89128,22.34545 Z",
    id: "Stroke-15",
    stroke: "#EE7330",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.27824,38.87524 L29.27824,28.70604 C30.81564,27.03124 31.75434,24.79814 31.75434,22.34544 C31.75434,19.89284 30.81564,17.65974 29.27824,15.98494 L29.27824,5.81554",
    id: "Stroke-17",
    stroke: "#222456",
    strokeWidth: 1.2607,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.48053,5.81557 L15.48053,15.91197 C13.90303,17.59457 12.93653,19.85697 12.93653,22.34547 C12.93653,24.83397 13.90303,27.09637 15.48053,28.77897 L15.48053,38.87527",
    id: "Stroke-19",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93019,8.0476 C43.93019,12.2633 40.51269,15.6808 36.29689,15.6808 C32.08119,15.6808 28.66369,12.2633 28.66369,8.0476 C28.66369,3.8319 32.08119,0.4143 36.29689,0.4143 C40.51269,0.4143 43.93019,3.8319 43.93019,8.0476",
    id: "Fill-21",
    fill: "#BE1622"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.04274,
    y1: 5.7934,
    x2: 38.55114,
    y2: 10.3018,
    id: "Stroke-23",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.55114,
    y1: 5.7934,
    x2: 34.04274,
    y2: 10.3018,
    id: "Stroke-25",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup27);
export default __webpack_public_path__ + "static/media/Group 27.d0577402.svg";
export { ForwardRef as ReactComponent };